const PaymentMessage = () => {
    return (
        <div id="paymentMessage">
            <p>Welcome to IPRS Health</p>
            <p>
                As part of IPRS Health services delivered in partnership with
                your private medical insurer there may be times you become
                liable for costs in relation to your treatment. This could be
                for the following reasons:
            </p>
            <p>
                If your insurance policy is cancelled, lapsed, or expires and
                you continue to receive treatment, you would be responsible for
                the costs of the treatment from the point of no cover.
            </p>
            <p>
                If you cancel an appointment and fail to give 24 hours' notice
                that you are unable to attend, or if you do not show up for an
                appointment, you may be charged a no show fee, this is not
                covered by your insurance policy, so is passed on to you.
            </p>
            <p>
                If you have an excess on your policy or if you exceed any policy
                benefit limits your private medical insurer will advise us of
                this and we will request a payment from you to cover these
                areas.
            </p>
            <p>
                To streamline your onward journey, we would like to validate a
                payment card, that we will hold securely and only use if one of
                the above scenarios occur during your treatment with us. To
                validate your card a £1.00 validation transaction is processed;
                however, this is refunded back to you, by IPRS Health.
            </p>
            <p>
                If IPRS Health do debit your card, we always provide you with 5
                working days' notice, by email. The email will state the reasons
                why we need to debit the card, the amount, and our contact
                details in case you have any questions.
            </p>
            <p>
                Please provide below the card details that you would like IPRS
                Health to validate. We thank you in advance.
            </p>
        </div>
    );
};

export default PaymentMessage;
